import React, { ReactNode, forwardRef } from 'react'

import HtmlViewer from 'client/components/HtmlViewer'
import styles from './styles.module.css'
import cn from 'classnames'

interface Props {
  title?: ReactNode
  children?: string
  hasStickyTitle?: boolean
}

const DescriptionItem = forwardRef<HTMLDivElement, Props>(
  ({ title, children, hasStickyTitle }, ref) => {
    if (!children) {
      return <></>
    }

    return (
      <div ref={ref}>
        {title && (
          <h4 className={cn(styles.descriptionItemTitle, { [styles.sticky]: hasStickyTitle })}>
            {title}
          </h4>
        )}
        <p className={styles.descriptionItem}>
          <HtmlViewer html={children} />
        </p>
      </div>
    )
  }
)

export default DescriptionItem
